import React, { ReactNode } from 'react';

import { themeColors } from 'colors';
import Button from 'domains/core/components/Button';

const buttonStyles = {
    border: `2px solid ${themeColors.primary.main}`,
    borderRadius: 1,
    boxShadow: 'none',
    height: '60px',
    justifyContent: 'flex-start',
    margin: '8px',
    padding: '16px',
    width: '100%',
};

type ButtonProps = {
    'data-testid'?: string;
    disabled?: boolean;
    isActive?: boolean;
    icon: ReactNode;
    label: string;
    labelStyles?: React.CSSProperties;
    onClick?: () => void;
    value?: ReactNode;
};

const CustomCampaignNavigationButton = ({
    'data-testid': dataTestId,
    disabled,
    isActive,
    icon,
    label,
    labelStyles,
    onClick,
    value,
}: ButtonProps) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
        <Button
            data-testid={dataTestId}
            disabled={disabled}
            onClick={onClick}
            startIcon={icon}
            size="large"
            variant="outlined"
            sx={{
                ...buttonStyles,
                borderColor: isActive && themeColors.other.cumin,
                backgroundColor: isActive ? themeColors.other.garlic : undefined,
                pointerEvents: !onClick && 'none',
            }}
        >
            <span
                style={{
                    fontSize: '20px',
                    margin: '-2px 8px 0 0',
                    ...labelStyles,
                }}
            >
                {label}
            </span>
            <span style={{ lineHeight: 1.25, textAlign: 'left' }}>{value}</span>
        </Button>
    </div>
);

export default CustomCampaignNavigationButton;
